import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaLinkedin, FaFacebook } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer mt-auto py-2">
      <Container>
        <Row className="mt-2">
          <Col className="text-center">
            <p className="mb-0 small">
              &copy; {new Date().getFullYear()} Cogeis. {t('allRightsReserved')}.
            </p>
            <div className="social-icons mt-2">
              <a 
                href="https://www.linkedin.com/company/cogeis-srl/posts/?feedView=all" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link me-3"
              >
                <FaLinkedin size={24} />
              </a>
              <a 
                href="https://www.facebook.com/cogeisSRL/?locale=it_IT" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaFacebook size={24} />
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer; 